<script setup lang="ts">
import { computed } from "vue";

import type { iconName as iconNameType, iconSize } from "@/Modules/App/Models/Styles/Icons";
import type { colorTag } from "@/Modules/App/Models/Styles/Colors";

import IconResolver from "./TcIcon.vue";
import TcLoader from "@/Components/UI/TcLoader.vue";

export interface TcIconButtonProps {
  size?: iconSize;
  color?: colorTag;
  iconName: iconNameType;
  isLoading?: boolean;
}

const emit = defineEmits<{ (event: "click", value: Event): void }>();

const props = withDefaults(defineProps<TcIconButtonProps>(), {
  size: "md",
  color: "content-high",
  isLoading: false,
});

const iconSizeClass = computed(() => `icon-${props.size}-important`);

const handleClick = (e: MouseEvent) => {
  if (!props.isLoading) {
    emit("click", e);
  }
};
</script>

<template>
  <div class="icon_button" @click="handleClick">
    <IconResolver v-if="!props.isLoading" :name="props.iconName" :color="props.color" :size="props.size" />
    <TcLoader v-else :class="iconSizeClass" :color="props.color" />
  </div>
</template>

<style scoped lang="scss">
.icon_button {
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
